// Manual validators for the JSON shapes that travel over the wire. No zod
// dependency — the shape is small and stable, and a runtime validator keeps
// the bundle small.

import type { InterviewExtract, Goal } from '../types/interview';

function isString(v: unknown): v is string {
  return typeof v === 'string';
}

function isStringArray(v: unknown): v is string[] {
  return Array.isArray(v) && v.every(isString);
}

export function parseGoal(v: unknown): Goal | null {
  if (!v || typeof v !== 'object') return null;
  const o = v as Record<string, unknown>;
  if (!isString(o.id) || !isString(o.title)) return null;
  const status: Goal['status'] =
    o.status === 'in_progress' || o.status === 'done' ? o.status : 'open';
  const sub_goals = Array.isArray(o.sub_goals)
    ? (o.sub_goals.map(parseGoal).filter(Boolean) as Goal[])
    : undefined;
  return {
    id: o.id,
    title: o.title,
    rationale: isString(o.rationale) ? o.rationale : '',
    done_criteria: isString(o.done_criteria) ? o.done_criteria : '',
    status,
    sub_goals,
  };
}

export function parseExtract(v: unknown): InterviewExtract {
  if (!v || typeof v !== 'object') {
    return { topic: '', purpose: '', problem: '', solution: '', scope: '', goals: [], risks: [], next_steps: [] };
  }
  const o = v as Record<string, unknown>;
  return {
    topic: isString(o.topic) ? o.topic : '',
    purpose: isString(o.purpose) ? o.purpose : '',
    problem: isString(o.problem) ? o.problem : '',
    solution: isString(o.solution) ? o.solution : '',
    scope: isString(o.scope) ? o.scope : '',
    goals: Array.isArray(o.goals) ? (o.goals.map(parseGoal).filter(Boolean) as Goal[]) : [],
    risks: isStringArray(o.risks) ? o.risks : [],
    next_steps: isStringArray(o.next_steps) ? o.next_steps : [],
  };
}
